export const formatResult = (result: string): string => {
  if (!result) {
    console.warn('Result is empty');
    return 'EmptyResult';
  }

  switch (result) {
    case 'success':
      return 'Success';
    case 'failure':
      return 'Failure';
    case 'declined':
      return 'Declined';
    case 'ineligible':
      return 'Ineligible';
    case 'alreadyPerformed':
      return 'AlreadyPerformed';
    case 'interrupted':
      return 'Interrupted';
    default:
      return 'InvalidResult';
  }
};
